//* React imports
import { useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
//* Components imports
import Footer from "components/specific/LandingPage/Footer";
import HomePage from "screen/LandingPage";
import Navbar from "components/specific/LandingPage/Navbar";
import UnderConstruction from "components/common/UnderConstruction/UnderConstruction";
import PolicyPrivacy from "components/institucional/PolicyPrivacy/PolicyPrivacy";

const PublicRoutes = () => {
  // this structure is to get the scroll position
  // a lot of components are using this so dont delete it :)
  const [on_top, setOnTop] = useState(true);
  const [force_on_top, setForceOnTop] = useState(false);
  useEffect(() => {
    window.onscroll = () => {
      if (force_on_top) {
        setOnTop(false);
        return;
      }

      if (window.pageYOffset < 50) {
        setOnTop(true);
      } else {
        setOnTop(false);
      }
    };

    return () => (window.onscroll = null);
  });

  return (
    <>
      <Navbar {...{ on_top, setOnTop, setForceOnTop }} />

      <Routes>
        <Route path={"/*"} element={<HomePage {...{ on_top }} />} />
        <Route path={"/politica-de-privacidade"} element={<PolicyPrivacy />} />
        <Route path={"/termos-de-uso"} element={<UnderConstruction />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      <Footer />
    </>
  );
};

export default PublicRoutes;
